<template>
  <el-dialog
    :visible="visible"
    title="选择渠道"
    @close="handleCancel"
    width="70%"
    append-to-body
  >
    <div :style="{ maxHeight: '400px', overflowY: 'auto' }">
      <div
        v-for="group in groupChannelOptions"
        :key="group.brand + '-' + group.category"
        style="margin-bottom: 16px"
      >
        <div style="font-weight: bold; margin-bottom: 8px">
          {{ group.label }}
        </div>
        <el-checkbox-group v-model="localValue">
          <el-checkbox
            v-for="item in group.options"
            :key="item.productChannelCode"
            :label="item.productChannelCode"
            >{{ item.productChannelName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleCancel">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getProductChannelList } from "@/api/reviewOrder/index.js";
import { getDictLabelSync } from "@oppein/op-utils";

export default {
  name: "ProductChannelDialog",
  props: {
    // 控制对话框的显示和隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 选中的产品渠道值
    value: {
      type: Array,
      default: () => [],
    },
    // 品牌和品类的级联选择值
    brandCategoryValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localValue: [],
      // 产品渠道选项
      productChannelOptions: [],
    };
  },
  computed: {
    // 根据品牌和品类的级联选择值，生成分组的产品渠道选项
    groupChannelOptions() {
      // brandCategoryValue: [{brand, category}, ...]
      // productChannelOptions: [{productChannelCode, productChannelName, brand, category, ...}]
      if (
        !Array.isArray(this.brandCategoryValue) ||
        !this.brandCategoryValue.length
      )
        return [];

      return this.brandCategoryValue.map((brandCategoryItem) => {
        const options = this.productChannelOptions.filter(
          (item) =>
            item.brand === brandCategoryItem.brand &&
            item.category === brandCategoryItem.category,
        );

        return {
          brand: brandCategoryItem.brand,
          category: brandCategoryItem.category,
          label: `${getDictLabelSync(
            brandCategoryItem.brand,
            "ROOT_brand",
          )}-${getDictLabelSync(brandCategoryItem.category, "ROOT_category")}`,
          options,
        };
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.localValue = Array.isArray(val) ? [...val] : [];
      },
    },
  },
  mounted() {
    this.getProductChannelList();
  },
  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleConfirm() {
      this.$emit("update:visible", false);
      this.$emit("confirm", this.localValue);
    },
    /**
     * 获取产品渠道列表
     */
    async getProductChannelList() {
      const res = await getProductChannelList();
      this.productChannelOptions = res.data || [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductChannelDialog.vue?01261b6e